import form from './form'
import activeMenuTree from './activeMenuTree'
import menuPermissionList from './menu.permission.list'

export default {
    namespaced: true,
    modules: {
        "form": form,
        "activeMenuTree": activeMenuTree,
        "menuPermissionList": menuPermissionList,
    }
}
